import {MI} from "../init";
import {WinControl} from "./WinControl";
import {StormNormal} from "./StormNormal";
import {madnes_end_freespins, madnes_end_round} from "../../framework/src/engine/madnes/madnes";
import {ServerResultWinline} from "../ServerResultWinline";
import {BigWin} from "./BigWin";
import {STATES} from "../../framework/src/states/states";
import {states, wallet} from "../../framework/src/engine/madnes/madnes_variables";

/**
 * @constructor
 * @param {Game} game
 * @param {SymbolsManager} symbolsManager
 * @returns {ResultController}
 */
export function ResultController(game, symbolsManager) {
    this._game = game;

    this._sounds = game.sounds;

    /** @type {SymbolsManager} */
    this._symbolsManager = symbolsManager;

    this._controlLinePos = 0;
    this._controlResultPos = 0;

    /**
     * @type {Array|undefined}
     */
    this._lineWins;

    /**
     * @type {ServerResult}
     */
    this._serverResult;

    /**
     * @private
     * @type {WinControl}
     */
    this._winControl;

    this.resultWin = 0;
    this._roundWinTotal = 0;

    this._isWin = false;
    this._bigWinPlayed = false;

    /** @type {Storm|null}*/
    this._storm = null;

    this._forceAutostart = false;

    this._disableFsEnd = false;
};

/**
 * If in autostart, returns false
 * @returns {boolean}
 */
ResultController.prototype.autostartRemoveBetNextSpin = function() {
    if(this._game.isInAutostart()) {
        return false;
    } else {
        return true;
    }
};

/** @param {boolean} bool */
ResultController.prototype.setDisableFsEnd = function(bool) {
    this._disableFsEnd = bool;
};

//ResultController.prototype.init = function() {
//	this._winControl = new WinControl(this._game, this, this._symbolsManager);
//};

ResultController.prototype.incControlResultPos = function() {
    return ++this._controlResultPos;
};

/**
 * @returns {number}
 */
ResultController.prototype.getControlResultPos = function() {
    return this._controlResultPos;
};

/**
 * @returns {number}
 */
ResultController.prototype.getControlLinePos = function() {
    return this._controlLinePos;
};

/**
 * @param {boolean} b
 */
ResultController.prototype.setForceAutostart = function(b) {
    this._forceAutostart = b;
};

/** @returns {boolean} */
ResultController.prototype._isForceAutostart = function() {
    return this._forceAutostart;
};

/**
 * @param {ServerResult} serverResult
 */
ResultController.prototype.control = function(serverResult) {

    this._game.isRespin = false;

    this._winControl = new WinControl(this._game, this, serverResult, this._symbolsManager);

    this._serverResult = serverResult;
    this._lineWins = serverResult.getLineWins();

    this._controlLinePos = 0;
    this._controlResultPos = 0;

    this.resultWin = 0;
    this._roundWinTotal = serverResult.getLinesWinTotal();

    this._isWin = false;
    this._bigWinPlayed = false;

//	if(this.isBigWin() /*&& !this._game.isInFreeSpins()*/) {
//		return;
//	}

    this._controlWin();
};

/**
 * @returns {Promise}
 */
ResultController.prototype.playStorm = function() {
    if(this.isBigWin() && this._storm === null) {
        return this._runStorm();
    }

    return new Promise(function(res) { res(); });
};

/**
 * @returns {Promise}
 */
ResultController.prototype._runStorm = function() {

    var _self = this;

    return new Promise(function(res) {

        // MI.controls.hideStop();

        MI.createTimer().add(function() {
            MI.shakeScreenXY(0.003, 0.0015, 1300);
        }, 600);

        MI.createTimer().add(function() {
            _self._sounds["bwin_BigWin_Thunder"].play();
        }, 400);

        var storm1 = new StormNormal(_self._game.assets.getStormGroup());
        storm1.create(6, 500, 1500);
        storm1.play();

        _self._storm = new StormNormal(_self._game.assets.getStormGroup());
        _self._storm.create(2, 700, 2000);

        MI.createTimer().add(function() {
            storm1.stop();
            _self._storm.play();
            res();
        }, 2000);
    });
};

ResultController.prototype._controlWinNext = function() {
    this._controlLinePos++;
    this._controlWin();
};

ResultController.prototype._controlWin = function() {
    var _self = this;

    var winline = this._getActualLineWin();

    if(!winline) {
        this._winControl.end().then(function() {
            _self._endControl();
        });
        return;
    }

    this._game.setForceAutostartEnabled(false);
    states.setState(STATES.SKIP);

    // MI.controls.hideStop();

    this._isWin = true;

    var control = this._winControl.init();
    this._winControl.setNextWinLine(this._getNextLineWin());
    this._winControl.run(winline);

    control.then(function() {
        _self._controlWinNext();
    });
};

/**
 * @param {number} index
 * @returns {ServerResultWinline|undefined}
 */
ResultController.prototype._getLineWin = function(index) {

    if(!this._lineWins || !this._lineWins[index]) {
        return;
    }

    var resultWinline = new ServerResultWinline();
    resultWinline.init(this._lineWins[index]);

    return resultWinline;
};

/**
 * @returns {ServerResultWinline|undefined}
 */
ResultController.prototype._getActualLineWin = function() {
    return this._getLineWin(this._controlLinePos);
};

/**
 * @returns {ServerResultWinline|undefined}
 */
ResultController.prototype._getNextLineWin = function() {
    return this._getLineWin(this._controlLinePos + 1);
};

/** @returns {number} */
ResultController.prototype._getLineWinCountLeft = function() {
    return this._lineWins ? Object.keys(this._lineWins).length - this._controlLinePos : 0;
};

ResultController.prototype._endControl = function() {

    MI.controls.winAnimReset();

    this._game.resetRespins();

    var win = this._game.getWin();
    if(this._game.isInFreeSpins()) {
        win = this._game.getFreeSpinRoundWin();
    }

    if(this._isBigWinType(win) && !this._bigWinPlayed && !this._game.fsSkip) {
        this._endRoundBigWin(win);
        return;
    }

    if(this._game.isInFreeSpins()) {
        this._endFreeSpinRound();
        return;
    }

    this._sounds["bg_Music"].fadeToInit(500);

    //console.log(this._game.getWin());

    if(this._game.getWin() > 0) {

        this._endRoundWin(win);

    } else {

        this._endRoundNoWin();

    }
};

ResultController.prototype._endFreeSpinRound = function() {

    var _self = this;

    if(this._game.fsSkip) {

        this._game.fsSkip = false;

        this._disableFsEnd = false;
        // MI.server.setRoundRunning(true);
        // MI.controls.showAllBtns();
        // MI.controls.showSpin();
        // this._endResultControl(true);
        // return;
    }

    var fsWin = this._serverResult.getLinesWinTotal(); //this._game.freeSpinData["roundWin"];
    //var fsPos = this._game.fsSkip ? 0 : this._game.inFreeSpinsIndex + 1;
    var fsPos = this._game.inFreeSpinsIndex + 1;
    var fsCount = this._game.freeSpinData["count"];

    if(this._game.isNextRoundFreeSpin()) {

        this._sounds["bg_FreeSpins_Loop"].fadeToInit(500);

        this._game.setFreeSpinRoundWin(0);
        madnes_end_round();

        // this._endRoundServer(false, {},{ win: fsWin, order: fsPos, count: fsCount }).then(function() {
        //
        //     MI.controls.showAllBtns();
        //     MI.server.setRoundRunning(true);
        //     MI.controls.hideStop();
        //     MI.controls.showSpin();
        //
        //     if(this._game.inFreeSpinsIndex >= 0) {
        //         MI.setCookie("lfspos_" + MI.server.getSessionId(), this._game.inFreeSpinsIndex);
        //     }
        //
        //     this._game.setFreeSpinRoundWin(0);
        //
        //     this._endResultControl(true);
        //
        // }.bind(this));

    } else {

        madnes_end_freespins();

        var win = MI.getWin();

        // MI.controls.hideAllBtns();

        states.setState(STATES.BONUS_WIN);

        this._runFS(MI.moneyToCoin(win)).then(function() {

            _self._game.leaveFreeSpins();

            // var betRemoved = false;

            // _self._game.isInAutostart() && MI.controls.showAllBtns();

            madnes_end_round();

            // _self._endRoundServer(true, {}, { win: fsWin, order: fsPos, count: fsCount }).then(function() {

                // betRemoved = _self._game.isInAutostart();

                // MI.setCookie("lfspos_" + MI.server.getSessionId(), "", -1);

                // MI.controls.showAllBtns();
                // MI.controls.hideStop();

                // MI.recountBet(win);
                // _self._recountBalance(betRemoved);
                // MI.setWin(0);

                // _self._endResultControl(false);

            // });
        });
    }
};

/** @param {number} win - in `money` */
ResultController.prototype._endRoundWin = function(win) {

    // var _self = this;
    //
    // this._endRoundServer(true, {}, {}).then(function() {
    //     _self._endResultControl();
    // });

    madnes_end_round();
};

ResultController.prototype._endRoundNoWin = function() {
//      var _self = this;
//     this._game.isInAutostart() && MI.controls.showAllBtns();
// //	MI.controls.hideStop();
//
//     this._endRoundServer(true, {}, {}).then(function() {
//         _self._endResultControl();
//     });

    madnes_end_round();
};

/** @param {number} win - in `money`  */
ResultController.prototype._endRoundBigWin = function(win) {
    var _self = this;

    states.setState(STATES.BONUS_WIN);

    // MI.controls.hideAllBtns();

    this._runBW(MI.moneyToCoin(win)).then(function() {
        _self._endControl();
    });
};

/**
 */
ResultController.prototype._endResultControl = function(inFreespins) {

    // MI.controls.showAllBtns();
    //
    // if(!inFreespins) {
    //     madnes_on_end_round_recount(win);
    //     madnes_on_round_end();
    //     madnes_recount_bet();
    // }
    //
    // this._game.runBgMusicTimer();
    // this._game.spinEnabled = true;
    //
    // this._game.setForceAutostartEnabled(false);
    // if(this._game.isInAutostart() || this._isForceAutostart())
    // {
    //     this.setForceAutostart(false);
    //
    //     MI.rotateStart();
    //     return;
    // }
};

/**
 * @param {boolean} ended
 * @param {Object=} roundData
 * @param {Object=} fsData
 * @returns {Promise}
 */
ResultController.prototype._endRoundServer = function(ended, roundData, fsData) {
//	MI.controls.showStop();
//	MI.controls.hideSpin();
    return MI.server.endRound(ended, roundData, fsData);
};

// /**
//  * @param {boolean=} removebet
//  */
// ResultController.prototype._recountBalance = function(removebet) {
//     MI.recountBalance(MI.server.getEndRoundTmp(), removebet);
// };

/**
 * @param {number=} win in `money`
 * @returns {boolean}
 */
ResultController.prototype._isBigWinType = function(win) {

    if(!win) {
        return false;
    }

    var winType = this._game.getWinType(win, MI.getBet());
    if(winType >= this._game.BIG_WIN && winType <=	this._game.SUPER_MEGA_WIN) {
        return true;
    }

    return false;
};

/** @returns {boolean} */
ResultController.prototype.isBigWin = function() {
    return this._game.isBigWin(this._roundWinTotal, MI.getBet());
};

/**
 * @param {number} win - in `coins`
 * @returns {Promise}
 */
ResultController.prototype._runBW = function(win) {
    var _self = this;

    this._storm && this._storm.stop();
    this._storm = null;

    return new Promise(function(res) {

        if(_self._game.isInFreeSpins()) {
            _self._sounds["bg_FreeSpins_Loop"].fadeOut(100, false);
        } else {
            _self._sounds["bg_Music"].fadeOut(100, false);
        }

        _self._sounds["bwin_BigWin"].play();

        var bigWin = new BigWin(_self._game);
        bigWin.create("bigwin", win);
        bigWin.play().then(function() {

            MI.setInMoneyAdd(false);

            _self._bigWinPlayed = true;

//			if(_self._game.isInFreeSpins() {
//				_self._bigWinPlayed = true;
//				//this._game.freeSpinData["roundWin"] = 0;
//			} else {
//				_self._game.setWin(0);
//			}

            res();
        });
    });
};

/**
 * @param {number} coins
 * @returns {Promise}
 */
ResultController.prototype._runFS = function(coins) {

    this._sounds["bg_FreeSpins_Loop"].fadeOut(200, true);
    this._sounds["bwin_FreeSpins"].play();

    var bigWin = new BigWin(this._game);
    bigWin.create("freespinswin", coins);
    return bigWin.play();
};